import MAction from "./MAction.vue";

export * from "./_types";
export default MAction;
